import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Dialog, DialogActions, DialogContent, DialogContentText, Button, DialogTitle } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd, MdApproval, MdArrowBack, MdArrowRightAlt, MdClass, MdDone, MdEmail, MdInbox, MdMail, MdMarkunreadMailbox, MdOutlineApproval, MdOutlineSettingsSuggest, MdPassword, MdRememberMe, MdResetTv, MdSchool, MdSend, MdSettings, MdSettingsAccessibility } from "react-icons/md";
import { Commet } from "react-loading-indicators";
import { useNavigate } from "react-router-dom";
import { } from "rsuite";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";
function ResearcherUsernameResetPasswordPage() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setStudentEmail("")
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    let name = "Roy";

    const [studentEmail, setStudentEmail] = useState('')

    const [error, setError] = useState({
        invalidEmail: false,
        noEmail: false
    })

    const [isLoading, setIsLoading] = useState(false);

    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err?.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));


        } else if (err?.toLowerCase().includes('no student found')) {
            setErrorMsg(t('t128'));

        } else {
            setErrorMsg(t('t94'));

        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        setStudentEmail("")
    };

    const handleButtonClick = () => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const nameRegex = /^(?!.*script)[a-z0-9.]{7,}$/i;
        let newErrors = {};

        newErrors.noEmail = !studentEmail;

        if ((studentEmail) && !emailRegex.test(studentEmail) && !nameRegex.test(studentEmail)) {
            newErrors.invalidEmail = true;
        } else {
            newErrors.invalidEmail = false;
        }

        setError(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        axios.get(`${web_url}/api/auth/students/${studentEmail}`, configToken)
            .then((response) => {
                setIsLoading(false);
                localStorage.setItem('studentEmailForResetPassword', studentEmail);
                navigate('/researcher/resetpassword/student');
            })
            .catch((err) => {

                if (err?.response) {
                    if (err.response.data?.message) {
                        handleClickOpenError(err.response.data.message);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
                setIsLoading(false);
            })
    }

    useEffect(() => {
        localStorage.removeItem('studentEmailForResetPassword');
    }, []);

    return (
        <>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} overflow-x-hidden min-h-screen w-screen xl:pt-[20px]`}>
                <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                    <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            navigate('/researcher/resetpassword')
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            navigate('/researcher/resetpassword')
                        }} />
                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                            navigate('/researcher/resetpassword')
                        }} />
                        <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t113')}</p>
                    </div>
                </div>

                <div className="flex justify-center mt-[40px]">
                    <img src="/images/reset_password.svg" alt="add students" />
                </div>
                <div className="ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdEmail size="24px" color="#8189B0" />
                    <input value={studentEmail} type="text" name="email" className={`ml-[10px] w-full bg-[#F1F6FB] ${i18n.language === "en" ? "text-[15px]" : "text-[13px]"} md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t441')}
                        onChange={(e) => {
                            setStudentEmail(e.target.value.toLowerCase())
                        }}
                    />
                </div>

                {error.noEmail &&
                    <p className='ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] text-[#ff0000] text-[12px] mt-[5px]'>{t('t442')}</p>
                }
                {error.invalidEmail &&
                    <>
                        <p className='ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] text-[#ff0000] text-[12px] mt-[5px]'>{t('t443')}</p>
                        <p className='ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] text-[#ff0000] text-[12px] mt-[5px]'>{t('t444')}</p>
                        <p className='ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] text-[#ff0000] text-[12px] mt-[5px]'>{t('t445')}</p>

                    </>
                }

                <div className="flex justify-center">
                    <button onClick={handleButtonClick} disabled={isLoading} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] md:w-[500px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">
                        {isLoading ? (
                            <div className="items-center justify-center flex">
                                <div className='w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin'></div>
                            </div>
                        ) : (
                            t('t155')
                        )}
                    </button>
                </div>

            </div>
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm mr-[30px] md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">
                    {!isLoading &&
                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/success.svg' alt='success' />
                                <div className='mt-[30px] mb-[20px]'>{t('t127')}</div>
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t96')}
                                </Button>
                            </div>
                        </DialogContent>
                    }
                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2 ">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ResearcherUsernameResetPasswordPage;
